import { Machine } from 'xstate';

export default Machine({
  key: 'header',
  initial: 'idle',
  states: {
    idle: {
      on: {
        EDIT_PROFILE: 'edit_profile',
        EDIT_COMPANY_INFO: 'edit_company_info',
        GET_PROFILE: 'loading',
        INVITE: 'invite',
        SETTINGS: 'settings',
      },
    },
    edit_profile: {
      on: {
        CLOSE: 'idle',
      },
    },
    edit_company_info: {
      on: {
        CLOSE: 'idle',
      },
    },
    invite: {
      on: {
        CLOSE: 'idle',
      },
    },
    settings: {
      on: {
        CLOSE: 'idle',
      },
    },
  },
});
